<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <payment-section ref="paymentSectionVisible"></payment-section>
      </div>
    </div>
  </div>
</template>
<script>
import {Autocomplete, Input, Drawer, Button, RadioGroup, Radio, RadioButton, DatePicker, CheckboxGroup, CheckboxButton} from 'element-ui'
import {FormatterUtils} from '../../../../../utils/Formatter.js'
import {ValidationUtils} from '../../../../../utils/Validation.js'
import {TranslationsUtils} from '../../../../../utils/Translations'
import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
import PaymentSection from '../../Utils/PaymentSection'
//  PATIENT NAME
//  PATIENT ADDRESS
//  PATIENT SEX
//  PATIENT DOB
//  PATIENT PHONE NUMBER
//  PATIENT EMAIL ADDRESS
//  PATIENT INSURANCE DETAILS
export default {
  components: {
    [Input.name]: Input,
    [DatePicker.name]: DatePicker,
    [Autocomplete.name]: Autocomplete,
    [Drawer.name]: Drawer,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    [CheckboxButton.name]: CheckboxButton,
    [CheckboxGroup.name]: CheckboxGroup,
    PaymentSection
  },
  mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, SettingsUtils],
  data () {
    return {
      model: {}
    }
  },
  beforeMount () {},
  methods: {
    async validate () {
      if ((this.$store.state.configs['FORCE_PAYMENT_ON_REGISTRATION'] === true && this.$store.state.insuranceType === 'cash' && this.$store.state.cashPayment === 'card') || this.$store.state.configs['AT_HOME_COLLECTION'] === true) {
        let ValidatePayment = await this.$refs.paymentSectionVisible.validate()
        if (ValidatePayment.valid !== false) {
          this.model = Object.assign(this.model, ValidatePayment)
        } else {
          return false
        }
      }
      return true
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/_variables.scss";

>>>.el-select--large{
  width: 100%;
}

>>>.el-autocomplete{
  width: 100%;
}

h5{
  margin-bottom: 25px;
}

.display-none {
  display: none;
}

.generic-answer {
  margin-top: 10px;
}

.float-right{
  float: right;
}

.p-0{
  padding: 0;
}

.w-100{
  width: 100% !important;
}

.pr-0{
  padding-right: 0;
}

.p-10{
  padding: 10px;
}

.pt-10{
  padding-top: 10px;
}

.scan-button{
  font-size: 17px;
  background: white;
  border: 1px solid red;
  border-radius: 5px;
}

.line-clamp {
  text-overflow: ellipsis;
  overflow: hidden;
  /* width: 500px; */
  height: 1.2em;
  white-space: nowrap;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.d-inline-block{
  display: inline-block;
}

.mt-5{
  margin-top: 5px;
}

.mt-10{
  margin-top: 10px;
}

.general-inactive-section:focus-within {
  border-left-color: $primary-color !important;
}

@media screen and (max-width: 991px) {
  .mt-5{
    margin-top: 0;
  }

  .mb-0{
    margin-bottom: 0;
  }

  .pr-0{
    padding-left: 0;
  }
}

@media screen and (max-width: 365px) {
  >>> .el-radio-button--small .el-radio-button__inner {
    padding: 9px 7px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/Wizard/PaymentStep.vue